import { createSerializer, parseAsString } from 'nuqs'
import { TracingAreaRoutes } from '../TracingAreaRoutes'

// nuqs rather than URLSearchParams: it leaves the colons in the timestamps
// readable, so a linked-to search renders the same URL the search form writes.
const serialize = createSerializer({
  region_id: parseAsString,
  // The key the global fleet dropdown reads. Kept as a literal so this lib does
  // not depend on service-area-picker.
  fleet_id: parseAsString,
  vehicleIdentifier: parseAsString,
  identifierValue: parseAsString,
  startDateTime: parseAsString,
  endDateTime: parseAsString,
})

/** The wall clock the vehicle search reads, in UTC and without an offset suffix. */
const toSearchParam = (date: Date): string =>
  `${date.toISOString().slice(0, 19)}`

export type VehicleTracingLinkParams = {
  vehicleId: string
  from: Date
  until: Date
  /**
   * Required: the result page resolves its region, and therefore the operator
   * tenant every cube query needs, from this param alone. Without it the page
   * renders with nothing selected and fetches nothing.
   */
  regionId: string
  fleetId: string
}

/**
 * Link into the vehicle result for a given vehicle and window. Lives here rather
 * than in fleet-tracing so trip-tracing can link across without importing its
 * sibling feature.
 */
export const buildVehicleTracingLink = ({
  vehicleId,
  from,
  until,
  regionId,
  fleetId,
}: VehicleTracingLinkParams): string =>
  serialize(TracingAreaRoutes.Vehicle.route, {
    region_id: regionId,
    fleet_id: fleetId,
    vehicleIdentifier: 'uuid',
    identifierValue: vehicleId,
    startDateTime: toSearchParam(from),
    endDateTime: toSearchParam(until),
  })
